"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../../utilities/ServiceFetch"));
var exceptions_1 = require("@ikea-aoa/exceptions");
/**
 * This service handles IOWS authentication.
 */
var IowsAuthenticationService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.consumer Consumer.
     * @param options.contract Contract.
     * @param options.endpoint Endpoint.
     */
    function IowsAuthenticationService(options) {
        this.consumer = null;
        this.contract = null;
        this.endpoint = null;
        this.consumer = options.consumer;
        this.contract = options.contract;
        this.endpoint = options.endpoint;
    }
    /**
     * Authenticates and returns an IOWS user.
     *
     * @returns Promise.
     */
    IowsAuthenticationService.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, window.fetch(this.endpoint, {
                                headers: this.getHeaders(),
                                credentials: 'include'
                            })];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw new exceptions_1.ConnectionProblemException(this.endpoint);
                    case 3:
                        if (!(response.status === 419)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.clearUser()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getUser()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, response.json()];
                    case 7:
                        data = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_2 = _a.sent();
                        throw new exceptions_1.UnableToParseServerResponseException(response);
                    case 9:
                        if (!data['SessionContext']) {
                            throw new exceptions_1.ServiceException('Failed to fetch user. Response data did not include SessionContext.');
                        }
                        return [2 /*return*/, {
                                id: String(data['SessionContext'].UserId.$)
                            }];
                }
            });
        });
    };
    /**
     * Clears user session.
     *
     * @returns Promise object.
     */
    IowsAuthenticationService.prototype.clearUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            method: 'DELETE',
                            headers: this.getHeaders(),
                            credentials: 'include'
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns headers.
     *
     * @returns Headers.
     */
    IowsAuthenticationService.prototype.getHeaders = function () {
        return {
            accept: 'application/vnd.ikea.iows+json;version=2',
            consumer: this.consumer,
            contract: String(this.contract)
        };
    };
    return IowsAuthenticationService;
}());
exports.default = IowsAuthenticationService;
//# sourceMappingURL=IowsAuthenticationService.js.map